import { render, staticRenderFns } from "./S3Image.vue?vue&type=template&id=5621f367&scoped=true&"
import script from "./S3Image.vue?vue&type=script&lang=ts&"
export * from "./S3Image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5621f367",
  null
  
)

export default component.exports